module.exports = __webpack_public_path__ + "img/camscom.dd3b922.png";